// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__16kbP","choiceBoxes":"toolbarselects_choiceBoxes__bagsh","simpleField":"toolbarselects_simpleField__3JFoy"};